import React from "react";
import "./Footer.scss";
import { FaFacebookF, FaInstagram,FaPhoneAlt, FaClock, FaMapMarkerAlt,FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";
import rohanSysImg from '../../assets/rohan-systems-pics/logo-removebg-preview.png';


const Footer = () => {
  const footerMenu = [
    {
      name: "About Us",
      link: "/about",
    },
    {
      name: "Servics",
      link: "/",
    },
    {
      name: "Testimonials",
      link: "/",
    },
    {
      name: "Contact Us",
      link: "/",
    },
  ];

  const footerContacts = [
    {
      title: "Phone Number",
      info2: "+91 9922566050",
      info: "+91 9822636411",
      icon:<FaPhoneAlt />,
    },
    {
      title: "Open Hour",
      info: "10:00 AM - 09:00 PM",
      icon: <FaClock />,
    },
    {
      title:"Email",
      info:"rohansystems@gmail.com",
      icon: <FaEnvelope />,
    },
    {
      title: "Office Address",
      info: "Shop no 3, Shri Krishna Empire, Purnanagar, Chinchwad, Pune 411019",
      icon: <FaMapMarkerAlt />,
    },
  ];

  return (
    <footer className="common-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-5">
            <div className="footer-logo">
              {/* <img src={ivoryimg} alt="logo" /> */}
              <Link className="navbar-brand" to="/">
              <img src={rohanSysImg} className='company-logo' />
              <span className="Logo-text">Rohan <br></br>Systems</span>
              </Link>
            </div>
            <p className="footer-text">
            Rohan Systems is a leading IT solutions and services provider in Pune, trusted for delivering innovative and reliable technology solutions
            </p>

            <div className="social-logo">
              <p>Follow us on</p>
              <ul>
                <li>
                  <a href="https://www.facebook.com/share/1TqSP4egjw/" target="blank">
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/_rohan_systems?igsh=eWZkb2QxY2theG9k" target="blank">
                    <FaInstagram />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-2">
            <div className="footer-link">
              <p>Quick Links</p>
              <ul>
                {footerMenu.map((singleMenu) => (
                  <li>
                    <Link to="/">{singleMenu.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-5">
            <div className="footer-contact">
              <p>Contact & Information</p>

              {footerContacts.map((footerContact) => {
                return (
                  <div className="contact-list">
                    <div className="footer-icons">
                    {footerContact.icon} 
                    </div>
                    <div className="contact-text">
                      <p>{footerContact.title}</p>
                      <h5>{footerContact.info}</h5>
                      <h5>{footerContact.info2}</h5>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="copyright-area">
          <div className="copy-text">
            <p>&copy; Rohan Systems. All Right Reserved</p>
          </div>
          <div className="copy-links">
            <ul>
              <li>
                <Link to="/">Terms of Use</Link>
              </li>
              <li>
                <Link to="/">Privacy Policy</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
